<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?(viewFlag?'查看常见问题':'编辑常见问题'):'新增常见问题'" :visible.sync="dialog" @close="unShowClick()" width="40%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="常见问题名称" prop="problem" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" v-model="addBody.problem"
						placeholder="请输入常见问题名称"></el-input>
				</el-form-item>
				<el-form-item label="常见问题解答" prop="answer" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" type="textarea" :rows="5"
						v-model="addBody.answer" placeholder="请输入1-500位内容，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="权重" prop="weight" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" v-model="addBody.weight"
						placeholder="请输入大于0的数字"></el-input>
					<div style="color: #999;">*权重数字越大排序越靠前</div>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer" v-if="!viewFlag">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateProblem('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addProblem,
		updateProblem,
		getProblemDetail
	} from '@/api/views'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					problem: '',
					answer: "",
					weight: '',
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					problem: [{
						required: true,
						message: '请输入常见问题名称',
						trigger: 'blur'
					}, ],
					answer: [{
						required: true,
						message: '请输入常见问题解答',
						trigger: 'blur'
					}, ],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					},{
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					} ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				viewFlag: false
			}
		},
		mounted() {},
		methods: {
			setViewFlag(viewFlag) {
				this.viewFlag = viewFlag
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateProblem(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateProblem()
						} else {
							this.network().addProblem()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.viewFlag = false
				this.$emit('input', false)
			},
			network() {
				return {
					addProblem: async () => {
						const {
							status,
							data
						} = await addProblem({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateProblem: async () => {
						const {
							status
						} = await updateProblem({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getProblemDetail: async (uuid) => {
						const {
							data,
							status
						} = await getProblemDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getProblemDetail(val.uuid)
				} else {
					this.isEdit = false
					this.addBody.problem = ''
					this.addBody.answer = ''
					this.addBody.weight = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>